import React, { useEffect } from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { Dialog as DialogComponent, OkButton, Overlay } from "@plex/react-components";

import { Banner } from "ui/app";
import { DialogContainer } from "ui/app/navigation/dialog";
import { useLocalizedValues } from "ui/hooks";
import { securityMessages } from "ui/screens";

import { RoleMembersHistoryFilter, RoleMembersHistoryGrid } from "./components";
import { roleMembersHistoryActions } from "./RoleMembersHistory.actions";
import { IRoleMembersHistoryState, IRoleMembersHistoryInitData } from "./RoleMembersHistory.state";

interface IRoleMembersHistoryProps {
  state: IRoleMembersHistoryState;
  securityRoleId: string;
  tenantId: string;
  initRoleMembersHistory: (initData: IRoleMembersHistoryInitData) => void;
  loadRoleMembersHistory: () => void;
  clearState: () => void;
}

const RoleMembersHistory: React.FC<IRoleMembersHistoryProps> = ({ state, tenantId, securityRoleId, initRoleMembersHistory, loadRoleMembersHistory, clearState }) => {
  useEffect(() => {
    initRoleMembersHistory({ tenantId, securityRoleId });
    loadRoleMembersHistory();
  }, [initRoleMembersHistory, loadRoleMembersHistory, tenantId, securityRoleId]);

  const localizedValues = useLocalizedValues(() => ({
    dialogTitle: securityMessages.title("roleMembersHistory")
  }));
  return (
    <DialogContainer
      onHidden={clearState}
      render={dialogProps => {
        return (
          <DialogComponent {...dialogProps} title={localizedValues.dialogTitle}>
            <DialogComponent.Body>
              <Overlay show={state.isLoading} showSpinner />
              <Banner messages={state.notifications} />
              <RoleMembersHistoryFilter />
              <RoleMembersHistoryGrid data={state.data} />
            </DialogComponent.Body>
            <DialogComponent.Footer>
              <OkButton onClick={dialogProps.onHide} />
            </DialogComponent.Footer>
          </DialogComponent>
        );
      }}
    />
  );
};

export default connect(
  (state: { roleMembersHistory: IRoleMembersHistoryState }) => {
    return {
      state: state.roleMembersHistory
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        initRoleMembersHistory: roleMembersHistoryActions.initRoleMembersHistory,
        loadRoleMembersHistory: roleMembersHistoryActions.loadRoleMembersHistory,
        clearState: roleMembersHistoryActions.reset
      },
      dispatch
    )
)(RoleMembersHistory);
